export default {
    state: {
        play: false,
        timer: {},
    },
    mutations: {
        SET_TIMER(state, timer) {
            state.timer = { ...state.timer, ...timer };
        },

        SET_PLAY(state, played) {
            state.play = played;
        },
    },

    actions: {
        setTimer({ commit }, timer) {
            commit("SET_TIMER", timer);
        },

        setPlayTimer({ commit }, played) {
            commit("SET_PLAY", played);
        },
    },
};
